import { takeLatest, call, put } from 'redux-saga/effects';

import API_ENDPOINTS from '@services/apiConfig';
import AuthManager from '@services/AuthManager';
import RestClient from '@services/RestClient';

import { merchantSelectors, dialogActions } from '.';

//  Action types
export const actionTypes = {
  fetchHubToken: 'fetchHubToken/INITIATE',
  fetchHubTokenSuccess: 'fetchHubToken/SUCCESS',
  fetchHubTokenFailed: 'fetchHubToken/FAILED',
};

const initialState = {
  data: {}
};

//  Reducer
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetchHubTokenSuccess:
      return { data: action.payload }    
    default: {
      return state;
    }
  }
};

//  Selectors
export const selectors = {
  getHubToken: (state) => state.onboardingApp.hub.data.access_token,
};


//  Actions
export const actions = {
  fetchHubToken: () => ({ type: actionTypes.fetchHubToken }),
};

//  Workers
function* fetchHubTokenWorker() {
  try {
    const response = yield call(
      [RestClient, 'post'],
      API_ENDPOINTS.HUB_TOKEN,
      {
        client_id: process.env.HUB_CLIENT_ID,
        grant_type: 'client_credentials',
        scope: "find_or_create send_sign_in_otp verify_sign_in_otp"
      },
    ) || {};
    yield put({ type: actionTypes.fetchHubTokenSuccess, payload: response });
  } catch {
    yield put({ type: actionTypes.fetchHubTokenFailed, payload: 'send-otp-error' });
  }
}

//  Sagas
export function* saga() {
  yield takeLatest(actionTypes.fetchHubToken, fetchHubTokenWorker);
}